import { render } from "./EstadisticaCobranza.vue?vue&type=template&id=13488b26"
import script from "./EstadisticaCobranza.vue?vue&type=script&lang=js"
export * from "./EstadisticaCobranza.vue?vue&type=script&lang=js"

import "./EstadisticaCobranza.vue?vue&type=style&index=0&id=13488b26&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__